(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/coupon/outcomes.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/coupon/outcomes.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.Outcomes = Marionette.CollectionView.extend({
    className: 'view-outcomes js-outcomes outcomes',

    options: {
      percentActive: false
    },

    template: function(data) {
      return svs.matchen.templates.outcomes(data);
    },

    childViewContainer: '.outcomes-list',

    childView: function() {
      if (this.getOption('percentActive')) {
        return svs.matchen.views.OutcomePercent;
      }
      return svs.matchen.views.Outcome;
    },

    childViewOptions: function() {
      return {
        maxPercent: this.collection.maxPercent
      };
    }
  });
})(Backbone, _, svs);


 })(window);